module.exports = __webpack_public_path__ + "static/media/yes_no_btn03.6a4e06a8.png";